import { useParams } from 'react-router-dom';
import { blogs } from '../data/blogData';
import ReactMarkdown from "react-markdown";
import NavbarComponent from '../components/navbar';
import FooterComponent from '../components/footer';

const Blog = () => {
    const { id } = useParams();

    const blog = blogs.find(blog => blog.id === id);

    if (!blog) {
        return <h1>Blog not found</h1>
    }
    
    return(
        <>
            <NavbarComponent />
                <div className='blog'>
                    <h2 className='mb-4'>{blog.title}</h2>
                    <p className='mb-4'><em>{blog.date}</em></p>
                    <ReactMarkdown>{blog.content}</ReactMarkdown>
                </div>
            <FooterComponent />
        </>
    );
};

export default Blog;